// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2563":"259dc358","8882":"59499404"}[chunkId] + ".css";
};